import {MessageModel} from '../../../models/message.model';
import {ItemMapper} from '../../../lib/item-mapper';

export class PurchaseGiftMapper extends ItemMapper<MessageModel> {
  protected mapFromItem(item): MessageModel {
      const messageObj = new MessageModel();
      messageObj.code = item.sessionId;

      return messageObj;
  }
}
